import { callApiWithAuthorization } from "../CallApi";

export const getProjectRoles = async (projectId) => {
    try {
        const request = await callApiWithAuthorization(`/api/v0/roles/${projectId}`)
        const result = await request.json()
        return result
    } catch (e) {
        return e
    }
}

export const updateRole = async (id, properties) => {
    try {
        const request = await callApiWithAuthorization(`/api/v0/role/${id}`, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(properties)
        })
        const result = await request.json()
        return result
    } catch (e) {
        return e
    }
}

export const createRole = async (projectId, properties) => {
    try {
        const request = await callApiWithAuthorization(`/api/v0/role/${projectId}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(properties)
        })
        const result = await request.json()
        return result
    } catch (e) {
        return e
    }
}

export async function deleteRole(projectId, roleId) {
    try {
        await callApiWithAuthorization("/api/v0/project/" + projectId + "/role/" + roleId, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
			}
		})
    } catch (e) {
        return e
    }
}

export async function updateAttributesBasedonEntityRight(roleId, entityId, attributeValue) {
    await callApiWithAuthorization("/api/v0/updateAttributesBasedonEntityRight", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            roleId,
            entityId,
            attributeValue: attributeValue
        })
    })
}

export async function updatePagesBasedonEntityRight(roleId, entityId, pageValue) {
    await callApiWithAuthorization("/api/v0/updatePagesBasedonEntityRight", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            roleId,
            entityId,
            pageValue
        })
    })
}

export async function updateSpecificPageBasedonEntityRight(roleId, entityId, pageValue, subPageType) {
    await callApiWithAuthorization("/api/v0/updateSpecificPageBasedonEntityRight", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            roleId,
            entityId,
            pageValue,
            subPageType
        })
    })
}